import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { Board, PageTop, Title, TitleArea } from "components/LayoutParts";
import Loading from "components/Loading";
import UserModal, { UserModalConfig } from "components/UserModal";
import {
  PIT_PORT_PAGINATION_DEFAULT_INDEX,
  PIT_PORT_PAGINATION_DEFAULT_TOTAL_PAGES,
} from "pages/PitPort/constants/pagination";

import { useFindOwnerEntities } from "./api";
import ActionArea from "./DataTable/ActionArea";
import DataTable from "./DataTable/index";

const ButtonWrap = styled.div`
  margin-left: auto;
`;

/**
 * 貸主一覧画面
 */
const OwnerEntity = () => {
  const navigate = useNavigate();
  const onClickOwnerEntityAdd = () => {
    navigate("/pit_port/owner-entities/create");
  };
  const [originList, setOriginList] = useState<OwnerEntity[]>([]);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(PIT_PORT_PAGINATION_DEFAULT_INDEX);
  const [totalPages, setTotalPages] = useState<number>(PIT_PORT_PAGINATION_DEFAULT_TOTAL_PAGES);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isModalShow, setIsModalShow] = useState(false);
  const hideModal = () => setIsModalShow(false);
  const showModal = () => setIsModalShow(true);

  const ownerEntityModalConfig: UserModalConfig = {
    onClickOutside: hideModal,
    subtitle: "送信に失敗しました",
    main: {
      buttonType: "secondary",
      onClick: hideModal,
      label: "閉じる",
    },
  };

  const { data, error } = useFindOwnerEntities({
    pageIndex: currentPageIndex,
    keyword: searchKeyword,
  });

  const fetch = useCallback(async () => {
    if (error) {
      showModal();
      return;
    }
    if (!data) return;
    setTotalPages(data.totalPages);
    setOriginList(data.data);
  }, [data, error]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKeyword(e.target.value);
  };

  return (
    <>
      <Board>
        <PageTop />
        <TitleArea>
          <Title>貸主</Title>
          <ButtonWrap>
            <Button label="貸主を追加" onClick={onClickOwnerEntityAdd} type="primary" />
          </ButtonWrap>
        </TitleArea>
        <ActionArea searchKeyword={searchKeyword} onSearchChange={onSearchChange} />
        {data ? (
          <DataTable
            userList={originList}
            totalPages={totalPages}
            pageIndex={currentPageIndex}
            setPageIndex={setCurrentPageIndex}
            searchKeyword={searchKeyword}
          />
        ) : (
          <Loading />
        )}
      </Board>
      <UserModal isVisible={isModalShow} config={ownerEntityModalConfig}></UserModal>
    </>
  );
};

export default OwnerEntity;
